module.exports = __webpack_public_path__ + "static/media/Lato-black.5407de99.eot";